import React from "react";
import MainPage from "../pages/MainPage/MainPage";
import ShelterListPage from "../pages/ShelterListPage/ShelterListPage";
import ShelterPage from "../pages/ShelterPage/ShelterPage";
import WheaterPage from "../pages/WeatherPage/WeatherPage";
import JobOfferListPage from "../pages/JobOfferListPage/JobOfferListPage";
import JobOfferPage from "../pages/JobOfferPage/JobOfferPage";
import { Routes, Route } from "react-router-dom";
import MaterialHelpListPage from "../pages/MaterialHelpListPage/MaterialHelpListPage";

function CustomRoutes() {
  return (
    <Routes>
      <Route path="/" element={<MainPage />} />
      <Route path="/noclaharne" element={<ShelterListPage />} />
      <Route path="/noclaharne/:id" element={<ShelterPage />} />
      <Route path="/pocasie" element={<WheaterPage />} />
      <Route path="/ponukaprace" element={<JobOfferListPage />} />
      <Route path="/ponukaprace/:id" element={<JobOfferPage />} />
      <Route path="/materialnapomoc" element={<MaterialHelpListPage />} />
    </Routes>
  );
}

export default CustomRoutes;
